webpackJsonp([192093764125380],{

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Fonts'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Webpack is configured with support for the font formats ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ttf'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'otf'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'eot'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'woff'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'woff2'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Relevant Section'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section of the Webpack config that controls this behavior is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        test: /\\.(ttf|otf|eot|woff(2)?)(\\?[a-z0-9]+)?$/,\n        use: {\n          loader: \'file-loader\',\n          options: {\n            name: ifProduction(\n              \'assets/fonts/[name].[hash:8].[ext]\',\n              \'assets/fonts/[name].[ext]\'\n            )\n          }\n        }\n      },\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-features-fonts-js-d556a973ea549765d734.js